webpackJsonp([114276838955818,60335399758886],{

/***/ 111:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(207);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(111);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

	var requestFrame = (function () {
	  var window = this
	  var raf = window.requestAnimationFrame ||
	    window.mozRequestAnimationFrame ||
	    window.webkitRequestAnimationFrame ||
	    function fallbackRAF(func) {
	      return window.setTimeout(func, 20)
	    }
	  return function requestFrameFunction(func) {
	    return raf(func)
	  }
	})()
	
	var cancelFrame = (function () {
	  var window = this
	  var cancel = window.cancelAnimationFrame ||
	    window.mozCancelAnimationFrame ||
	    window.webkitCancelAnimationFrame ||
	    window.clearTimeout
	  return function cancelFrameFunction(id) {
	    return cancel(id)
	  }
	})()
	
	function resizeListener(e) {
	  var win = e.target || e.srcElement
	  if (win.__resizeRAF__) {
	    cancelFrame(win.__resizeRAF__)
	  }
	  win.__resizeRAF__ = requestFrame(function () {
	    var trigger = win.__resizeTrigger__
	    trigger.__resizeListeners__.forEach(function (fn) {
	      fn.call(trigger, e)
	    })
	  })
	}
	
	var exports = function exports(element, fn) {
	  var window = this
	  var document = window.document
	  var isIE
	
	  var attachEvent = document.attachEvent
	  if (typeof navigator !== 'undefined') {
	    isIE = navigator.userAgent.match(/Trident/) ||
	      navigator.userAgent.match(/Edge/)
	  }
	
	  function objectLoad() {
	    this.contentDocument.defaultView.__resizeTrigger__ = this.__resizeElement__
	    this.contentDocument.defaultView.addEventListener('resize', resizeListener)
	  }
	
	  if (!element.__resizeListeners__) {
	    element.__resizeListeners__ = []
	    if (attachEvent) {
	      element.__resizeTrigger__ = element
	      element.attachEvent('onresize', resizeListener)
	    } else {
	      if (getComputedStyle(element).position === 'static') {
	        element.style.position = 'relative'
	      }
	      var obj = (element.__resizeTrigger__ = document.createElement('object'))
	      obj.setAttribute(
	        'style',
	        'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1; opacity: 0;'
	      )
	      obj.setAttribute('class', 'resize-sensor')
	      obj.__resizeElement__ = element
	      obj.onload = objectLoad
	      obj.type = 'text/html'
	      if (isIE) {
	        element.appendChild(obj)
	      }
	      obj.data = 'about:blank'
	      if (!isIE) {
	        element.appendChild(obj)
	      }
	    }
	  }
	  element.__resizeListeners__.push(fn)
	}
	
	module.exports = typeof window === 'undefined' ? exports : exports.bind(window)
	
	module.exports.unbind = function (element, fn) {
	  var attachEvent = document.attachEvent
	  if (fn) {
	    element.__resizeListeners__.splice(
	      element.__resizeListeners__.indexOf(fn),
	      1
	    )
	  } else {
	    element.__resizeListeners__ = []
	  }
	  if (!element.__resizeListeners__.length) {
	    if (attachEvent) {
	      element.detachEvent('onresize', resizeListener)
	    } else {
	      element.__resizeTrigger__.contentDocument.defaultView.removeEventListener(
	        'resize',
	        resizeListener
	      )
	      delete element.__resizeTrigger__.contentDocument.defaultView.__resizeTrigger__
	      element.__resizeTrigger__ = !element.removeChild(
	        element.__resizeTrigger__
	      )
	    }
	    delete element.__resizeListeners__
	  }
	}


/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	var now = __webpack_require__(371)
	  , global = typeof window === 'undefined' ? {} : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = global['request' + suffix]
	  , caf = global['cancel' + suffix] || global['cancelRequest' + suffix]
	  , isNative = true
	
	for(var i = 0; i < vendors.length && !raf; i++) {
	  raf = global[vendors[i] + 'Request' + suffix]
	  caf = global[vendors[i] + 'Cancel' + suffix]
	      || global[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  isNative = false
	
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  if(!isNative) {
	    return raf.call(global, fn)
	  }
	  return raf.call(global, function() {
	    try{
	      fn.apply(this, arguments)
	    } catch(e) {
	      setTimeout(function() { throw e }, 0)
	    }
	  })
	}
	module.exports.cancel = function() {
	  caf.apply(global, arguments)
	}


/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.6.3
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/*
	//@ sourceMappingURL=performance-now.map
	*/
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)))

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	var ReactDOM = __webpack_require__(112);
	var elementResizeEvent = __webpack_require__(302);
	
	module.exports = {
	  getInitialState: function() {
	    if (this.props.initialComponentWidth !== undefined && this.props.initialComponentWidth !== null) {
	      return {
	        componentWidth: this.props.initialComponentWidth
	      };
	    } else {
	      return {};
	    }
	  },
	  // Add our resize sensor.
	  componentDidMount: function() {
	    this.setState({
	      componentWidth: ReactDOM.findDOMNode(this).getBoundingClientRect().width
	    });
	    elementResizeEvent(ReactDOM.findDOMNode(this), this.onResize);
	  },
	  // When the DOM updates, check that our resize sensor is still there.
	  componentDidUpdate: function() {
	    if (0 === ReactDOM.findDOMNode(this).getElementsByClassName('resize-sensor').length) {
	      elementResizeEvent(ReactDOM.findDOMNode(this), this.onResize);
	    }
	  },
	  onResize: function() {
	    this.setState({
	      componentWidth: ReactDOM.findDOMNode(this).getBoundingClientRect().width
	    });
	  }
	};


/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.2
	var resizeListener;
	
	resizeListener = __webpack_require__(440);
	
	module.exports = {
	  getInitialState: function() {
	    if (this.props.initialPageWidth) {
	      return {
	        pageWidth: this.props.initialPageWidth
	      };
	    } else {
	      return {};
	    }
	  },
	  componentDidMount: function() {
	    return resizeListener.on(this.onResize);
	  },
	  componentWillUnmount: function() {
	    return resizeListener.off(this.onResize);
	  },
	  onResize: function(pageWidth) {
	    return this.setState({
	      pageWidth: pageWidth
	    });
	  }
	};


/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.2
	var currentWidth, onResize, raf, subscribers, ticking, update;
	
	raf = __webpack_require__(370);
	
	currentWidth = void 0;
	
	subscribers = [];
	
	ticking = false;
	
	if (typeof window !== "undefined" && window !== null) {
	  currentWidth = window.innerWidth;
	}
	
	onResize = function() {
	  if (!ticking) {
	    ticking = true;
	    return raf(update);
	  }
	};
	
	update = function() {
	  var i, len, subscriber;
	  currentWidth = window.innerWidth;
	  for (i = 0, len = subscribers.length; i < len; i++) {
	    subscriber = subscribers[i];
	    subscriber(currentWidth);
	  }
	  return ticking = false;
	};
	
	if (typeof window !== "undefined" && window !== null) {
	  window.addEventListener("resize", onResize);
	}
	
	module.exports = {
	  on: function(subscribeFn) {
	    subscribeFn(currentWidth);
	    return subscribers.push(subscribeFn);
	  },
	  off: function(subscribeFn) {
	    return subscribers.splice(subscribers.indexOf(subscribeFn), 1);
	  }
	};


/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	var ComponentWidthComponent, PageWidthComponent, PageWidthMixin, React, componentWidthMixin, objectAssign;
	
	React = __webpack_require__(2);
	
	componentWidthMixin = __webpack_require__(372);
	
	PageWidthMixin = __webpack_require__(439);
	
	objectAssign = __webpack_require__(3);
	
	ComponentWidthComponent = React.createClass({
	  displayName: "Breakpoint",
	  mixins: [componentWidthMixin],
	  propTypes: {
	    minWidth: React.PropTypes.number,
	    maxWidth: React.PropTypes.number
	  },
	  getDefaultProps: function() {
	    return {
	      minWidth: 0,
	      maxWidth: 1000000000000000000000
	    };
	  },
	  renderChildren: function() {
	    return React.Children.map(this.props.children, (function(_this) {
	      return function(child) {
	        var ref;
	        if ((child != null ? (ref = child.type) != null ? ref.displayName : void 0 : void 0) === "Span") {
	          return React.cloneElement(child, {
	            context: _this.props.context
	          });
	        } else {
	          return child;
	        }
	      };
	    })(this));
	  },
	  render: function() {
	    var props, ref;
	    props = objectAssign({}, this.props);
	    delete props.maxWidth;
	    delete props.minWidth;
	    delete props.widthMethod;
	    if (this.state.componentWidth) {
	      if ((this.props.minWidth <= (ref = this.state.componentWidth) && ref < this.props.maxWidth)) {
	        return React.createElement("div", Object.assign({}, props), this.renderChildren());
	      } else {
	        return React.createElement("div", null);
	      }
	    } else {
	      return React.createElement("div", null);
	    }
	  }
	});
	
	PageWidthComponent = React.createClass({
	  displayName: "Breakpoint",
	  mixins: [PageWidthMixin],
	  propTypes: {
	    minWidth: React.PropTypes.number,
	    maxWidth: React.PropTypes.number
	  },
	  getDefaultProps: function() {
	    return {
	      minWidth: 0,
	      maxWidth: 1000000000000000000000
	    };
	  },
	  renderChildren: function() {
	    return React.Children.map(this.props.children, (function(_this) {
	      return function(child) {
	        var ref;
	        if (((ref = child.type) != null ? ref.displayName : void 0) === "Span") {
	          return React.cloneElement(child, {
	            context: _this.props.context
	          });
	        } else {
	          return child;
	        }
	      };
	    })(this));
	  },
	  render: function() {
	    var props, ref;
	    props = objectAssign({}, this.props);
	    delete props.maxWidth;
	    delete props.minWidth;
	    delete props.widthMethod;
	    if (this.state.pageWidth) {
	      if ((this.props.minWidth <= (ref = this.state.pageWidth) && ref < this.props.maxWidth)) {
	        return React.createElement("div", Object.assign({}, props), this.renderChildren());
	      } else {
	        return React.createElement("div", null);
	      }
	    } else {
	      return React.createElement("div", null);
	    }
	  }
	});
	
	module.exports = React.createClass({
	  displayName: 'Breakpoint',
	  propTypes: {
	    widthMethod: React.PropTypes.string.isRequired,
	    minWidth: React.PropTypes.number,
	    maxWidth: React.PropTypes.number
	  },
	  getDefaultProps: function() {
	    return {
	      widthMethod: 'pageWidth'
	    };
	  },
	  render: function() {
	    if (this.props.widthMethod === "pageWidth") {
	      return React.createElement(PageWidthComponent, Object.assign({}, this.props));
	    } else if (this.props.widthMethod === "componentWidth") {
	      return React.createElement(ComponentWidthComponent, Object.assign({}, this.props));
	    }
	  }
	});


/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	var React, objectAssign;
	
	React = __webpack_require__(2);
	
	objectAssign = __webpack_require__(3);
	
	module.exports = React.createClass({
	  displayName: "Container",
	  render: function() {
	    var children, defaultStyles, props, styles;
	    defaultStyles = {
	      maxWidth: '960px',
	      marginLeft: 'auto',
	      marginRight: 'auto'
	    };
	    styles = objectAssign(defaultStyles, this.props.style);
	    children = this.props.children;
	    props = objectAssign({}, this.props);
	    delete props.children;
	    delete props.style;
	    return React.createElement("div", Object.assign({}, props, {
	      "style": styles
	    }), children, React.createElement("span", {
	      "style": {
	        display: 'block',
	        clear: 'both'
	      }
	    }, ' '));
	  }
	});


/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	var React, objectAssign;
	
	React = __webpack_require__(2);
	
	objectAssign = __webpack_require__(3);
	
	module.exports = React.createClass({
	  displayName: "Grid",
	  propTypes: {
	    columns: React.PropTypes.number,
	    gutterRatio: React.PropTypes.number
	  },
	  getDefaultProps: function() {
	    return {
	      columns: 12,
	      gutterRatio: 1 / 4
	    };
	  },
	  renderChildren: function() {
	    return React.Children.map(this.props.children, (function(_this) {
	      return function(child) {
	        var ref, ref1;
	        if ((ref = (ref1 = child.type) != null ? ref1.displayName : void 0) === "Breakpoint" || ref === "Span") {
	          return React.cloneElement(child, {
	            context: {
	              columns: _this.props.columns,
	              gutterRatio: _this.props.gutterRatio
	            }
	          });
	        } else {
	          return child;
	        }
	      };
	    })(this));
	  },
	  render: function() {
	    var props;
	    props = objectAssign({}, this.props);
	    delete props.gutterRatio;
	    delete props.columns;
	    return React.createElement("div", Object.assign({}, props), this.renderChildren(), React.createElement("span", {
	      "style": {
	        display: 'block',
	        clear: 'both'
	      }
	    }, ' '));
	  }
	});


/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	var React, objectAssign, spanCalculate;
	
	React = __webpack_require__(2);
	
	objectAssign = __webpack_require__(3);
	
	spanCalculate = __webpack_require__(446);
	
	module.exports = React.createClass({
	  displayName: "Span",
	  propTypes: {
	    context: React.PropTypes.object,
	    columns: React.PropTypes.number,
	    at: React.PropTypes.number,
	    pre: React.PropTypes.number,
	    post: React.PropTypes.number,
	    squish: React.PropTypes.number,
	    last: React.PropTypes.bool,
	    "break": React.PropTypes.bool
	  },
	  getDefaultProps: function() {
	    return {
	      at: 0,
	      pre: 0,
	      post: 0,
	      squish: 0,
	      last: false,
	      first: false,
	      "break": false
	    };
	  },
	  renderChildren: function() {
	    return React.Children.map(this.props.children, (function(_this) {
	      return function(child) {
	        var ref;
	        if ((child != null ? (ref = child.type) != null ? ref.displayName : void 0 : void 0) === "Span") {
	          return React.cloneElement(child, {
	            context: {
	              columns: _this.props.columns,
	              gutterRatio: _this.props.context.gutterRatio
	            }
	          });
	        } else {
	          return child;
	        }
	      };
	    })(this));
	  },
	  render: function() {
	    var props, style;
	    style = spanCalculate({
	      contextColumns: this.props.context.columns,
	      gutterRatio: this.props.context.gutterRatio,
	      columns: this.props.columns,
	      at: this.props.at,
	      pre: this.props.pre,
	      post: this.props.post,
	      squish: this.props.squish,
	      last: this.props.last,
	      "break": this.props["break"]
	    });
	    style = objectAssign(style, this.props.style);
	    props = objectAssign({}, this.props, {
	      "style": style
	    });
	    delete props.at;
	    delete props["break"];
	    delete props.columns;
	    delete props.context;
	    delete props.first;
	    delete props.last;
	    delete props.post;
	    delete props.pre;
	    delete props.squish;
	    delete props.style;
	    return React.createElement("div", Object.assign({}, props, {
	      "style": style
	    }), this.renderChildren(), React.createElement("span", {
	      "style": {
	        display: 'block',
	        clear: 'both'
	      }
	    }, ' '));
	  }
	});


/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	exports.Container = __webpack_require__(442);
	
	exports.Grid = __webpack_require__(443);
	
	exports.Breakpoint = __webpack_require__(441);
	
	exports.Span = __webpack_require__(444);


/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	var objectAssign;
	
	objectAssign = __webpack_require__(3);
	
	module.exports = function(options) {
	  var calcSpacing, calcSpanWidth, defaults, float, gutterWidth, marginLeft, marginRight, n, ops, width;
	  defaults = {
	    columns: 3,
	    at: 0,
	    pre: 0,
	    post: 0,
	    squish: 0,
	    contextColumns: 12,
	    gutterRatio: 1 / 4,
	    first: false,
	    last: false
	  };
	  ops = objectAssign(defaults, options);
	  n = 100 / (ops.contextColumns + ((ops.contextColumns - 1) * ops.gutterRatio));
	  gutterWidth = ops.gutterRatio * n;
	  calcSpanWidth = function(numColumns) {
	    return n * numColumns + gutterWidth * (numColumns - 1);
	  };
	  calcSpacing = function(numColumns) {
	    if (numColumns === 0) {
	      return 0;
	    } else {
	      return calcSpanWidth(numColumns) + gutterWidth;
	    }
	  };
	  width = calcSpanWidth(ops.columns);
	  if (ops.at === 0 && ops.pre === 0 && ops.squish === 0) {
	    marginLeft = 0;
	  } else {
	    marginLeft = calcSpacing(ops.at) + calcSpacing(ops.pre) + calcSpacing(ops.squish);
	  }
	  if (ops.last && ops.post === 0 && ops.squish === 0) {
	    marginRight = 0;
	  } else if (ops.post !== 0 || ops.squish !== 0) {
	    marginRight = calcSpacing(ops.post) + calcSpacing(ops.squish);
	    if (!ops.last) {
	      marginRight = marginRight + gutterWidth;
	    }
	  } else {
	    marginRight = gutterWidth;
	  }
	  if (ops.last) {
	    float = "right";
	  } else {
	    float = "left";
	  }
	  width = width + "%";
	  marginLeft = marginLeft + "%";
	  marginRight = marginRight + "%";
	  return {
	    float: float,
	    marginLeft: marginLeft,
	    marginRight: marginRight,
	    width: width,
	    clear: ops["break"] ? 'both' : 'none'
	  };
	};


/***/ }),

/***/ 304:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 157:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/background.038dd007.jpg";

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _typography = __webpack_require__(13);
	
	var _background = __webpack_require__(485);
	
	var _background2 = _interopRequireDefault(_background);
	
	var _logo = __webpack_require__(486);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	__webpack_require__(157);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Fullscreen = function (_Component) {
	  _inherits(Fullscreen, _Component);
	
	  function Fullscreen(props) {
	    _classCallCheck(this, Fullscreen);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      logoSize: 14,
	      nav: [{ path: '/project/', title: 'Projects' }, { path: '/blog/', title: 'Blog' }, { path: '/contact/', title: 'Contact' }]
	    };
	    return _this;
	  }
	
	  Fullscreen.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          backgroundImage: 'url(' + _background2.default + ')',
	          backgroundPosition: 'center',
	          backgroundSize: 'cover',
	          position: 'fixed',
	          height: '100%',
	          width: '100%'
	        }
	      },
	      _react2.default.createElement('canvas', {
	        style: {
	          display: 'inline-block',
	          width: '100%'
	        }
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            display: 'inline-block',
	            position: 'absolute',
	            width: '300px',
	            textAlign: 'center',
	            marginTop: '-150px',
	            marginLeft: '-150px',
	            top: '50%',
	            left: '50%'
	          }
	        },
	        _react2.default.createElement('img', { src: _logo2.default, style: { width: (0, _typography.rhythm)(this.state.logoSize) } }),
	        _react2.default.createElement(
	          'nav',
	          null,
	          _react2.default.createElement(
	            'ul',
	            null,
	            this.state.nav.map(function (element) {
	              return _react2.default.createElement(
	                'li',
	                {
	                  style: {
	                    display: 'inline-block',
	                    marginRight: (0, _typography.rhythm)(0.5)
	                  },
	                  key: element.path
	                },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    style: {
	                      color: 'white',
	                      boxShadow: 'none',
	                      fontFamily: 'Montserrat, sans-serif',
	                      fontWeight: 600,
	                      fontSize: (0, _typography.rhythm)(0.5),
	                      textTransform: 'uppercase'
	                    },
	                    href: element.path,
	                    title: element.title
	                  },
	                  element.title
	                )
	              );
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return Fullscreen;
	}(_react.Component);
	
	exports.default = Fullscreen;
	module.exports = exports['default'];

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.9bf49f58.png";

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsiveGrid = __webpack_require__(445);
	
	var _fullscreen = __webpack_require__(205);
	
	var _fullscreen2 = _interopRequireDefault(_fullscreen);
	
	var _typography = __webpack_require__(13);
	
	__webpack_require__(157);
	
	__webpack_require__(304);
	
	__webpack_require__(305);
	
	__webpack_require__(306);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Import typefaces
	
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children,
	        rootPath =  true ? ("") + '/' : '/';
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      location.pathname === rootPath && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_fullscreen2.default, null),
	        children()
	      ),
	      location.pathname !== rootPath && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', {
	          style: {
	            borderWidth: '' + (0, _typography.rhythm)(0.3),
	            borderTopStyle: 'solid'
	          }
	        }),
	        _react2.default.createElement(
	          _reactResponsiveGrid.Container,
	          {
	            style: {
	              maxWidth: (0, _typography.rhythm)(22),
	              padding: (0, _typography.rhythm)(1.5) + ' ' + (0, _typography.rhythm)(3 / 4)
	            }
	          },
	          _react2.default.createElement(
	            'h3',
	            {
	              style: {
	                fontFamily: 'Montserrat, sans-serif',
	                marginTop: 0,
	                marginBottom: (0, _typography.rhythm)(-1)
	              }
	            },
	            _react2.default.createElement(
	              'a',
	              {
	                style: {
	                  boxShadow: 'none',
	                  color: 'inherit',
	                  marginRight: (0, _typography.rhythm)(0.2),
	                  textDecoration: 'none'
	                },
	                href: '/'
	              },
	              'Home'
	            ),
	            '/contact/' === location.pathname && _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'span',
	                {
	                  style: {
	                    boxShadow: 'none',
	                    color: 'hsla(0,0%,0%,0.5)',
	                    marginRight: (0, _typography.rhythm)(0.2),
	                    textDecoration: 'none'
	                  }
	                },
	                '/'
	              ),
	              'Contact'
	            ),
	            '/project/' === location.pathname && _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'span',
	                {
	                  style: {
	                    boxShadow: 'none',
	                    color: 'hsla(0,0%,0%,0.5)',
	                    marginRight: (0, _typography.rhythm)(0.2),
	                    textDecoration: 'none'
	                  }
	                },
	                '/'
	              ),
	              'Project'
	            ),
	            -1 === ['/contact/', '/project/', rootPath].indexOf(location.pathname) && _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'span',
	                {
	                  style: {
	                    boxShadow: 'none',
	                    color: 'hsla(0,0%,0%,0.5)',
	                    marginRight: (0, _typography.rhythm)(0.2),
	                    textDecoration: 'none'
	                  }
	                },
	                '/'
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  style: {
	                    boxShadow: 'none',
	                    color: 'inherit',
	                    textDecoration: 'none'
	                  },
	                  href: '/blog/'
	                },
	                'Blog'
	              )
	            )
	          ),
	          children()
	        )
	      )
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ }),

/***/ 305:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-9311e12db28309f6a9fe.js